import BaseBridge from 'config/bridge/BaseBridge'
import BaseService from 'config/bridge/BaseService'
import { ICoveredCitiesResponse } from 'store/coveredCities/types'
import { ICoveredClinicsResponse } from 'store/coveredClinics/types'
import NewRelicUtils from 'config/monitoring/NewRelicUtils'
import { bridgeErrorToString } from 'utils/bridgeErrorToString'

import BridgeService from './bridgeService'

export default class AccreditedService {
  static async getCoveredCities() {
    try {
      const response = await BaseService.doExecute<ICoveredCitiesResponse>({
        method: 'GET',
        endpoint: `${process.env.REACT_APP_API_PET}/coverage/cities`,
      })

      return response.data
    } catch (error) {
      NewRelicUtils.noticeError(error as Error, {})

      console.error('Error fetching covered cities:', error)
      throw error
    }
  }

  static async getCoveredClinics(ibgeCode?: string, latitude?: string, longitude?: string) {
    const safeIbgeCode = ibgeCode ?? ''
    const safeLatitude = latitude === undefined || latitude === null ? undefined : String(latitude)
    const safeLongitude =
      longitude === undefined || longitude === null ? undefined : String(longitude)

    try {
      let headers = {}

      if (BaseBridge.isBrowser()) {
        headers = {
          'x-inter-customer-lat': safeLatitude,
          'x-inter-customer-lng': safeLongitude,
          ibgeCode: safeIbgeCode,
          'x-inter-user-bank-account': String((await BaseBridge.getUserInfo()).account),
        }
      } else {
        headers = {
          ibgeCode: safeIbgeCode,
          'x-inter-customer-lat': safeLatitude,
          'x-inter-customer-lng': safeLongitude,
        }
      }

      const response = await BaseService.doExecute<ICoveredClinicsResponse>({
        method: 'GET',
        endpoint: `${process.env.REACT_APP_API_PET}/coverage/clinics`,
        headers,
      })

      return response.data
    } catch (error) {
      BridgeService.tacWb({
        name: 'screen_partner_clinics_list',
        module: 'pet',
        actions: ['open_partner_clinics_via_home', 'open_partner_clinics_via_after_sales'],
        params: {
          ibgeCode: safeIbgeCode,
          error: bridgeErrorToString(error),
        },
        isError: true,
      })
      NewRelicUtils.noticeError(error as Error, {})
      console.error('Error fetching covered clinics:', error)
      throw error
    }
  }
}
